export const LIST_MODE_SWITCH_COMPONENT_KEY = 'ListModeSwitchComponent'

export interface ListModeSwitchConfig {
  icon: string
}

export const LIST_MODE_SWITCH_DEFAULT_CONFIG: ListModeSwitchConfig = {
  icon: 'Grid'
}
